export default {
    typesForSelect: (state) => state.typesForSelect,
    isLimitsTemplatesLoaded: (state) => state.limitsTemplates !== null,
    limitsTemplates: (state) => state.limitsTemplates !== null ? state.limitsTemplates : [],
    getTemplateName: (state) => (id) => {
        let value = state.limitsTemplates.find((template) => template.id === id);
        return value ? value.name : id
    },
    getTypeName: (state) => (type) => {
        if (!state.isLoadedTypesForSelect) {
            return type
        }
        let value = state.typesForSelect.find((option) => option.value == type);
        return value ? value.label : type
    },
    isLoadingTypesForSelect: (state) => state.isLoadingTypesForSelect,
    isLoadedTypesForSelect: (state) => state.isLoadedTypesForSelect,

    sidebetNames: (state) => state.sidebetNames !== null ? state.sidebetNames : [],
    isSidebetNamesLoaded: (state) => state.sidebetNames !== null,

    operatorsForSelect: (state) => state.operatorsForSelect,
    isLoadingOperatorsForSelect: (state) => state.isLoadingOperatorsForSelect,
    isLoadedOperatorsForSelect: (state) => state.isLoadedOperatorsForSelect,

    currenciesForSelect: (state) => state.currenciesForSelect,
    searchCurrenciesForSelect: (state) => (query) => {
        if (state.currenciesForSelect === null) {
            return [];
        }
        return state.currenciesForSelect.filter((item) => item.label.toLowerCase().startsWith(query.toLowerCase()))
    },
    isLoadingCurrenciesForSelect: (state) => state.isLoadingCurrenciesForSelect,
    isLoadedCurrenciesForSelect: (state) => state.isLoadedCurrenciesForSelect,

    defaultSettings: (state) => (gameType) => state.defaultSettings[gameType],
    isLoadingDefaultSettings: (state) => (gameType) => state.isLoadingDefaultSettings[gameType],

    copyFilterCurrencies: (state) => state.copyFilterCurrencies,
    copyFilterTables: (state) => state.copyFilterTables,
};
